import moment from 'moment';


export const buildDateUrl = (date) => {
  const momentDate = moment(date).utc();
  const month = momentDate.month() + 1;
  const day = momentDate.date();
  const parsedMonth = (month < 10) ? `0${month}` : month;
  const parsedDay = (day < 10) ? `0${day}` : day;

  return `/${momentDate.year()}/${parsedMonth}/${parsedDay}/nude-program`;
};

export const parseSlug = (arhive, typeOfListing, listingId, vintageSlug, searchSlug) => {
  let slug;
  switch (typeOfListing) {
    case 'segment':
      slug = `${arhive.slug}?segmentid=${listingId}`;
      break;
    case 'anchor':
      slug = `${arhive.slug}?anchorid=${listingId}`;
      break;
    case 'date':
      slug = buildDateUrl(arhive.date);
      break;
    case 'vintage':
      slug = `/${vintageSlug}/${arhive.slug}`;
      break;
    case 'search':
      slug = `/${arhive.slug}?search=${searchSlug}`;
      break;
    default:
      slug = buildDateUrl(arhive.date);
      break;
  }

  return slug;
};
